import { config } from 'config'
import { createClient } from 'contentful'

/**
 * space: id for the contentful project
 * delivery: access token for fetching published content
 * preview: access token for fetching all content including drafts (useful for previews)
 *
 * NOTE: If you want to leverage previews: env.jooraccess.com/r/passportpage?contentful-preview=true
 */
const QUERY_STRING = new URLSearchParams(window.location.search)
const USE_CONTENTFUL_PREVIEW =
  QUERY_STRING.get('contentful-preview') === 'true' || false
const CONTENTFUL_ENV =
  process.env.REACT_APP_ENV !== 'production' ||
  process.env.REACT_APP_ENV !== 'sandbox'
    ? (QUERY_STRING.get('contentful-env') ?? config.contentful.ENVIRONMENT)
    : config.contentful.ENVIRONMENT

export const contentfulClient = createClient({
  space: config.contentful.SPACE_ID,
  accessToken: USE_CONTENTFUL_PREVIEW
    ? config.contentful.PREVIEW_TOKEN
    : config.contentful.DELIVERY_TOKEN,
  host: USE_CONTENTFUL_PREVIEW
    ? config.contentful.PREVIEW_HOST
    : config.contentful.DELIVERY_HOST,
  environment: CONTENTFUL_ENV,
})

export const CONTENT_TYPES = {
  EVENTS: 'events',
  LANDING: 'passportLanding',
  SOCIAL: 'socialMedia',
  STYLE_STORIES: 'styleStories',
  STYLE_STORY_LAYOUTS: 'styleStoryLayouts',
  SHOWROOMS: 'showroom',
  RETAIL_BANNER: 'retailBanner',
  CTA_BANNERS: 'ctaBanners',
  CTA_BANNER_ITEM: 'ctaBannerItem',
}
